export const ADMIN_PROFILE_SETTINGS_TWO_FACTOR_AUTH_ROUTE_NAME = Symbol('admin.profile-settings.mfa');
export const AFFILIATE_PROFILE_SETTINGS_TWO_FACTOR_AUTH_ROUTE_NAME = Symbol('affiliate.profile-settings.mfa');

export const ADMIN_PROFILE_SETTINGS_TFA_GENERATE_URL = 'admin/profile/generate_google_secret';
export const AFFILIATE_PROFILE_SETTINGS_TFA_GENERATE_URL = 'affiliate/settings/generate_google_secret';
export const PROFILE_SETTINGS_TFA_GENERATE_MUTATION_KEY = 'profile-settings.tfa.generate';

export const ADMIN_PROFILE_SETTINGS_TFA_CONFIRM_URL = 'admin/profile/confirm_google_secret';
export const AFFILIATE_PROFILE_SETTINGS_TFA_CONFIRM_URL = 'affiliate/settings/confirm_google_secret';
export const PROFILE_SETTINGS_TFA_CONFIRM_MUTATION_KEY = 'profile-settings.tfa.confirm';

export const ADMIN_PROFILE_SETTINGS_TFA_CLEAR_URL = 'admin/profile/clear_google_secret';
export const AFFILIATE_PROFILE_SETTINGS_TFA_CLEAR_URL = 'affiliate/settings/clear_google_secret';
export const PROFILE_SETTINGS_TFA_CLEAR_MUTATION_KEY = 'profile-settings.tfa.confirm';
